module.exports = __webpack_public_path__ + "static/media/jumbo-2.159ae1c5.svg";